import { CommonKeys } from "../../../common/enums"
import { FORMULAR_META_WARTUNGS_STATES_TYPE } from "../../../common/formular-group-types"

export const FormularModelMetaWartungsStatesSchema = {
    $id: "FormularModelMetaWartungsStatesSchema",
    title: "FormularModelMetaWartungsStates Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_META_WARTUNGS_STATES_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: { $ref: "FormularModelMetaWartungsStateSchema" },
            nullable: true
        }
    }
}

export const FormularModelMetaWartungsStateSchema = {
    $id: "FormularModelMetaWartungsStateSchema",
    title: "FormularModelMetaWartungsState Schema",
    type: "object",
    properties: {
        Value: { type: "number", nullable: true },
        Label: { type: "string", nullable: true },
        SymbolCharHex: { type: "string", nullable: true },
        FontColorHex: { type: "string", nullable: true },
        BackColorHex: { type: "string", nullable: true },
        AppUseSymbolInsteadOfLabel: { type: "boolean", nullable: true },
    }
}